import {
  Component,
  useContext,
} from 'solid-js';
import {
  AppPage,
  AuthContext,
  FaIcon,
  Link,
  LocalizationContext,
  PageNotFound,
  Routes,
} from '../../components';
import { RouteAdmin } from './admin';
import { RouteExperiment } from './experiment';
import { RouteInvite } from './invite';
import {
  linkHome,
  linkMe,
  linkProjects,
  linkStore,
} from './links';
import { RouteLocal } from './local';
import { RouteMe } from './me';
import { RouteProjects } from './projects';
import { RouteStore } from './store';

export const RouteHome: Component = () => {
  const { status: authStatus } = useContext(AuthContext)!;
  const { t } = useContext(LocalizationContext)!;

  return <>
    <AppPage
      title={t('home')}
      breadcrumb={() => <Link href={linkHome}>{t('app.name')}</Link>}
      uiClass="home"
    />
    <Routes routes={[
      {
        path: '',
        component: () => <>
          <h1>{t(`app.name`)}<div class="hint">{t('home.header.hint')}</div></h1>
          {authStatus() == 'authenticated'
          ? <div class="links">
              <Link href={linkProjects}>
                <FaIcon weak inline fa-2xl solid briefcase />
                <span class="title">{t('projects')}</span>
                <span class="hint">{t('projects.hint')}</span>
              </Link>
              <Link href={linkMe}>
                <FaIcon weak inline fa-2xl solid id-card />
                <span class="title">{t('me')}</span>
                <span class="hint">{t('me.hint')}</span>
              </Link>
            </div>
          : <>
              <p>{t('home.description')}</p>
              <div class="links">
                <Link href={linkProjects}>
                  <FaIcon weak inline fa-2xl solid id-card />
                  <span class="title">{t('home.auth')}</span>
                  <span class="hint">{t('home.auth.hint')}</span>
                </Link>
              </div>
            </>
          }
          <div class="footer">
          </div>
        </>,
      },
      {
        path: 'projects',
        component: RouteProjects,
      },
      {
        path: 'store',
        component: RouteStore,
      },
      {
        path: 'me',
        component: RouteMe,
      },
      {
        path: 'invite',
        component: RouteInvite,
      },
      {
        path: 'local',
        component: RouteLocal,
      },
      {
        // sha256 of 'admin'
        path: '8c6976e5b5410415bde908bd4dee15dfb167a9c873fc4bb8a81f6f2ab448a918',
        component: RouteAdmin,
      },
      {
        path: 'experiment',
        component: RouteExperiment,
      },
      {
        component: PageNotFound,
      }
    ]} />
  </>;
};
